export type DateFormatOptions = Intl.DateTimeFormatOptions;

export function formatDateTime(
  isoString: string | null | undefined,
  options: DateFormatOptions = {
    dateStyle: 'medium',
    timeStyle: 'short',
  },
  locale: 'en-US'
): string {
  if (!isoString) return ''

  try {
    // Normalize microseconds if present (optional safety)
    const normalized = isoString.replace(/\.(\d{3})\d+/, '.$1')

    const date = new Date(normalized)

    if (isNaN(date.getTime())) {
      console.error('Invalid date:', isoString)
      return ''
    }

    return new Intl.DateTimeFormat(locale, options).format(date)
  } catch (err) {
    console.error('Date formatting error:', err)
    return ''
  }
}